import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2, X } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "payroll.exportCols.v1";
const DEFAULT = ["sicil_no", "ad_soyad", "sabit_maas", "yol_ucreti", "net_maas", "brut_maas", "banka_listesi"];

export const PayrollExportModal = ({ yil, ay, onClose }) => {
  const [cols, setCols] = useState([]);
  const [picked, setPicked] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || DEFAULT; } catch { return DEFAULT; }
  });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/payroll/export/columns").then((r) => setCols(r.data.columns)).catch(() => toast.error("Sütunlar yüklenemedi"));
  }, []);
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(picked)); }, [picked]);

  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  const ordered = cols.filter((c) => picked.includes(c.id)).map((c) => c.id);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/payroll/export?yil=${yil}&ay=${ay}&cols=${ordered.join(",")}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `bordro_${yil}_${String(ay).padStart(2, "0")}.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Excel indirildi");
      onClose();
    } catch { toast.error("Excel oluşturulamadı"); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" data-testid="payroll-export-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-xl max-h-[90vh] flex flex-col">
        <div className="p-3 border-b border-slate-200 flex items-center justify-between">
          <div>
            <div className="text-sm font-bold text-slate-900">Sütun Seçerek Excel'e Aktar</div>
            <div className="text-[11px] text-slate-500">Seçiminiz bir sonraki sefer için hatırlanır.</div>
          </div>
          <button onClick={onClose} data-testid="payroll-export-close" className="w-7 h-7 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={14} /></button>
        </div>
        <div className="px-3 pt-2 flex gap-3 text-[11px] font-semibold">
          <button onClick={() => setPicked(cols.map((c) => c.id))} data-testid="payroll-export-all" className="text-slate-600 hover:text-slate-900">Tümünü Seç</button>
          <button onClick={() => setPicked([])} data-testid="payroll-export-none" className="text-slate-600 hover:text-slate-900">Temizle</button>
          <button onClick={() => setPicked(DEFAULT)} data-testid="payroll-export-default" className="text-slate-600 hover:text-slate-900">Varsayılan</button>
        </div>
        <div className="p-3 grid grid-cols-2 gap-1 overflow-y-auto">
          {cols.map((c) => (
            <label key={c.id} className={`flex items-center gap-2 px-2 py-1.5 rounded-md text-xs cursor-pointer ${picked.includes(c.id) ? "bg-emerald-50 text-emerald-900" : "hover:bg-slate-50 text-slate-700"}`}>
              <input type="checkbox" checked={picked.includes(c.id)} onChange={() => toggle(c.id)} data-testid={`payroll-export-col-${c.id}`} />
              {c.label}
            </label>
          ))}
        </div>
        <div className="p-3 border-t border-slate-200 flex justify-end gap-2 bg-slate-50 rounded-b-xl">
          <button onClick={onClose} className="px-3 py-1.5 border border-slate-300 rounded-lg text-sm font-semibold">İptal</button>
          <button onClick={download} disabled={busy || !ordered.length} data-testid="payroll-export-download"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-700 hover:bg-green-800 text-white rounded-lg text-sm font-semibold disabled:opacity-50">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <FileSpreadsheet size={14} />} Excel İndir ({ordered.length})
          </button>
        </div>
      </div>
    </div>
  );
};
